import styled from "styled-components";

export const TextWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-wrap: break-word;
  font-family: Poppins-SemiBold;
  font-style: normal;
  font-weight: 500;
  font-size: 0.96rem;
  line-height: 1.85rem;
  margin-left: 0.57rem;
  color: #000000;
  margin-bottom: 0.8rem;
  width: fit-content;
  text-align: justify;
  /* cursor: pointer; */
`;
